import { jsx as _jsx } from "react/jsx-runtime";
import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AccountManagementTemplateLazy, CashFlowOverviewTemplateLazy, CashFlowStatementTemplateLazy, CashFlowTemplateTemplateLazy, CreateCashFlowTempTemplateLazy, DeptManagementTemplateLazy, ViewStatementTemplateLazy, EditCashflowStatementTemplateLazy, HomeTemplateLazy, LoginTemplateLazy, MultiLanguagesTemplateLazy, AggregrateCfTemplateLazy, SupplierManagementTemplateLazy, SupplierBalanceTemplateLazy, ApOverviewTemplateLazy, ArOverviewTemplateLazy, CustomerManagementTemplateLazy, CustomerLineItemsTemplateLazy, PaymentTemplateLazy, PaymentLogTemplateLazy, CreatePaymentProposalTemplateLazy, DunningLetterTemplateLazy, ExecutionLogTemplateLazy, CreateDunningLetterTemplateLazy, CustomerBalanceTemplateLazy, SupplierLineItemsTemplateLazy, LetterLayoutTemplateLazy
// Add Lazy Component Here
 } from '@src/routes/lazy';
import AuthLayout from '@libs/@core/layout/AuthLayout';
import HomeLayout from '@libs/@core/layout/HomeLayout';
import RootLayout from '@libs/@core/layout/RootLayout';
import { ViewCFTemplate, EditCashFlowTempTemplate } from '@modules/cashflow/cf-template/templates/index.template';
import NotFound from '@modules/_error/not-found';
import ProtectedLayout from '@libs/@core/layout/ProtectedLayout';
import { ACCOUNT_MANAGEMENT_URL, AGGREGRATE_CF_URL, AUTH_URL, CF_OVERVIEW_URL, CF_STATEMENT_URL, CF_TEMPLATE_URL, CREATE_CF_TEMPLATE_URL, DEPT_MANAGEMENT_URL, EDIT_CF_STATEMENT_URL, EDIT_CF_TEMPLATE_URL, LOGIN_URL, MULTI_LANGUAGE_URL, SUPPLIER_MANAGEMENT_URL, VIEW_CF_STATEMENT_URL, VIEW_CF_TEMPLATE_URL, SUPPLIER_BALANCE_URL, AP_OVERVIEW_URL, AR_OVERVIEW_URL, CUSTOMER_MANAGEMENT_URL, CUSTOMER_BALANCE_URL, VIEW_SUPPLIER_BALANCE_URL, VIEW_CUSTOMER_BALANCE_URL, CUSTOMER_LINE_ITEMS_URL, PAYMENT_URL, VIEW_PAYMENT_URL, CREATE_PAYMENT_URL, EDIT_PAYMENT_URL, CREATE_DUNNING_LETTER_URL, VIEW_DUNNING_LETTER_URL, DUNNING_LETTER_URL, EDIT_DUNNING_LETTER_URL, SUPPLIER_LINE_ITEMS_URL, LETTER_LAYOUT_URL
// Add URL Here
 } from '@src/routes/url';
import { getAutomaticDunningDetail, getAutomaticPaymentDetail, getCFStatementDetail, getCFTemplateDetail, getCustomerBalance, getCustomerItemList, getSupplierBalance, getSupplierItemList } from '@src/routes/loaders';
var routes = createBrowserRouter([
    {
        path: '*',
        element: _jsx(NotFound, {})
    },
    {
        path: '/',
        element: _jsx(RootLayout, {}),
        errorElement: _jsx(NotFound, {}),
        children: [
            {
                path: AUTH_URL,
                element: _jsx(AuthLayout, {}),
                children: [
                    {
                        path: LOGIN_URL,
                        element: _jsx(LoginTemplateLazy, {})
                    }
                ]
            },
            {
                path: '/',
                element: _jsx(HomeLayout, {}),
                children: [
                    {
                        path: '/',
                        element: _jsx(HomeTemplateLazy, {})
                    },
                    {
                        path: '',
                        element: _jsx(ProtectedLayout, {}),
                        children: [
                            // ========== Account Management Router ==========
                            {
                                path: ACCOUNT_MANAGEMENT_URL,
                                element: _jsx(AccountManagementTemplateLazy, {})
                            },
                            // ========== Multi Language Router ==========
                            {
                                path: MULTI_LANGUAGE_URL,
                                element: _jsx(MultiLanguagesTemplateLazy, {})
                            },
                            // ========== CF Overview Router ==========
                            {
                                path: CF_OVERVIEW_URL,
                                element: _jsx(CashFlowOverviewTemplateLazy, {})
                            },
                            // ========== CF Statement Router ==========
                            {
                                path: CF_STATEMENT_URL,
                                element: _jsx(CashFlowStatementTemplateLazy, {})
                            },
                            {
                                path: VIEW_CF_STATEMENT_URL,
                                loader: function (_a) {
                                    var params = _a.params;
                                    return getCFStatementDetail(params.id);
                                },
                                errorElement: _jsx(Navigate, { to: CF_STATEMENT_URL }),
                                element: _jsx(ViewStatementTemplateLazy, {})
                            },
                            {
                                path: EDIT_CF_STATEMENT_URL,
                                loader: function (_a) {
                                    var params = _a.params;
                                    return getCFStatementDetail(params.id);
                                },
                                errorElement: _jsx(Navigate, { to: CF_STATEMENT_URL }),
                                element: _jsx(EditCashflowStatementTemplateLazy, {})
                            },
                            // ========== CF Template Router ==========
                            {
                                path: CF_TEMPLATE_URL,
                                element: _jsx(CashFlowTemplateTemplateLazy, {})
                            },
                            {
                                path: VIEW_CF_TEMPLATE_URL,
                                loader: function (_a) {
                                    var params = _a.params;
                                    return getCFTemplateDetail(params.id);
                                },
                                errorElement: _jsx(Navigate, { to: CF_TEMPLATE_URL }),
                                element: _jsx(ViewCFTemplate, {})
                            },
                            {
                                path: EDIT_CF_TEMPLATE_URL,
                                loader: function (_a) {
                                    var params = _a.params;
                                    return getCFTemplateDetail(params.id);
                                },
                                errorElement: _jsx(Navigate, { to: CF_TEMPLATE_URL }),
                                element: _jsx(EditCashFlowTempTemplate, {})
                            },
                            {
                                path: CREATE_CF_TEMPLATE_URL,
                                element: _jsx(CreateCashFlowTempTemplateLazy, {})
                            },
                            // ========== Dept Management Router ==========
                            {
                                path: DEPT_MANAGEMENT_URL,
                                element: _jsx(DeptManagementTemplateLazy, {})
                            },
                            {
                                path: AGGREGRATE_CF_URL,
                                element: _jsx(AggregrateCfTemplateLazy, {})
                            },
                            {
                                path: SUPPLIER_MANAGEMENT_URL,
                                element: _jsx(SupplierManagementTemplateLazy, {})
                            },
                            {
                                path: SUPPLIER_BALANCE_URL,
                                errorElement: _jsx(Navigate, { to: SUPPLIER_MANAGEMENT_URL }),
                                element: _jsx(SupplierBalanceTemplateLazy, {})
                            },
                            {
                                path: VIEW_SUPPLIER_BALANCE_URL,
                                loader: function (_a) {
                                    var _b, _c;
                                    var params = _a.params;
                                    return getSupplierBalance({
                                        supplierCode: (_b = params.supplierCode) !== null && _b !== void 0 ? _b : '', // lấy từ params
                                        year: (_c = params.year) !== null && _c !== void 0 ? _c : '' // lấy từ params
                                    });
                                },
                                errorElement: _jsx(Navigate, { to: SUPPLIER_MANAGEMENT_URL }),
                                element: _jsx(SupplierBalanceTemplateLazy, {})
                            },
                            {
                                path: SUPPLIER_LINE_ITEMS_URL,
                                errorElement: _jsx(Navigate, { to: SUPPLIER_BALANCE_URL }),
                                element: _jsx(SupplierLineItemsTemplateLazy, {}),
                                loader: function (_a) {
                                    var _b, _c;
                                    var params = _a.params;
                                    console.log(params, 'param');
                                    return getSupplierItemList({
                                        supplierCode: (_b = params.supplierCode) !== null && _b !== void 0 ? _b : '', // lấy từ params
                                        year: (_c = params.year) !== null && _c !== void 0 ? _c : '', // lấy từ params,
                                        period: params.period
                                    });
                                }
                            },
                            {
                                path: AP_OVERVIEW_URL,
                                element: _jsx(ApOverviewTemplateLazy, {})
                            },
                            {
                                path: AR_OVERVIEW_URL,
                                element: _jsx(ArOverviewTemplateLazy, {})
                            },
                            {
                                path: CUSTOMER_MANAGEMENT_URL,
                                element: _jsx(CustomerManagementTemplateLazy, {})
                            },
                            {
                                path: CUSTOMER_BALANCE_URL,
                                element: _jsx(CustomerBalanceTemplateLazy, {})
                            },
                            {
                                path: VIEW_CUSTOMER_BALANCE_URL,
                                loader: function (_a) {
                                    var _b, _c;
                                    var params = _a.params;
                                    return getCustomerBalance({
                                        customerCode: (_b = params.customerCode) !== null && _b !== void 0 ? _b : '', // lấy từ params
                                        year: (_c = params.year) !== null && _c !== void 0 ? _c : '' // lấy từ params
                                    });
                                },
                                errorElement: _jsx(Navigate, { to: CUSTOMER_MANAGEMENT_URL }),
                                element: _jsx(CustomerBalanceTemplateLazy, {})
                            },
                            {
                                path: CUSTOMER_LINE_ITEMS_URL,
                                errorElement: _jsx(Navigate, { to: CUSTOMER_BALANCE_URL }),
                                element: _jsx(CustomerLineItemsTemplateLazy, {}),
                                loader: function (_a) {
                                    var _b, _c;
                                    var params = _a.params;
                                    console.log(params, 'param');
                                    return getCustomerItemList({
                                        customerCode: (_b = params.customerCode) !== null && _b !== void 0 ? _b : '', // lấy từ params
                                        year: (_c = params.year) !== null && _c !== void 0 ? _c : '', // lấy từ params,
                                        period: params.period
                                    });
                                }
                            },
                            { path: PAYMENT_URL, element: _jsx(PaymentTemplateLazy, {}) },
                            { path: VIEW_PAYMENT_URL, element: _jsx(PaymentLogTemplateLazy, {}) },
                            { path: CREATE_PAYMENT_URL, element: _jsx(CreatePaymentProposalTemplateLazy, {}) },
                            {
                                path: EDIT_PAYMENT_URL,
                                element: _jsx(CreatePaymentProposalTemplateLazy, {}),
                                loader: function (_a) {
                                    var params = _a.params;
                                    return getAutomaticPaymentDetail({
                                        id: Number(params.id)
                                    });
                                },
                                errorElement: _jsx(Navigate, { to: PAYMENT_URL })
                            },
                            { path: DUNNING_LETTER_URL, element: _jsx(DunningLetterTemplateLazy, {}) },
                            { path: VIEW_DUNNING_LETTER_URL, element: _jsx(ExecutionLogTemplateLazy, {}) },
                            { path: CREATE_DUNNING_LETTER_URL, element: _jsx(CreateDunningLetterTemplateLazy, {}) },
                            {
                                path: EDIT_DUNNING_LETTER_URL,
                                element: _jsx(CreateDunningLetterTemplateLazy, {}),
                                loader: function (_a) {
                                    var params = _a.params;
                                    return getAutomaticDunningDetail({
                                        id: Number(params.id)
                                    });
                                },
                                errorElement: _jsx(Navigate, { to: DUNNING_LETTER_URL })
                            },
                            {
                                path: LETTER_LAYOUT_URL,
                                element: _jsx(LetterLayoutTemplateLazy, {})
                            }
                            // Add Router Here
                        ]
                    }
                ]
            }
        ]
    }
]);
export default routes;
